import { BlogSectionType } from '../../../models/Content';

export const transformSectionText = (content: BlogSectionType) => {
    return {
        title: content.fields.title,
        text: content.fields.text,
        slug: content.fields.slug,
    };
};
